// 🔧 report_builder.js
// ✅ Purpose: Builds standardized Demo Engine execution reports
// ✅ Features:
// - Creates report data from DemoContext
// - Eliminates report creation logic from builders
// - Future-ready for add-on reporting
// - Fully block-commented for clarity and future devs

import { buildReportSummary } from "./report_summary";

export const buildExecutionReport = ({
  demoContext,
  pipelineResults,
} = {}) => {
  const report = {
    generatedAt: new Date().toISOString(),

    eventId:
      demoContext?.eventResult?.eventId || null,

    eventName:
      demoContext?.eventResult?.eventName || "",

    slug:
      demoContext?.eventResult?.slug || "",

    created: {
      categories:
        demoContext?.categories?.length || 0,

      entries:
        demoContext?.entries?.length || 0,

      users:
        demoContext?.users?.length || 0,

      votes:
        demoContext?.votes?.length || 0,
    },

    pipelineResults,
  };

  report.summary = buildReportSummary({
    report,
  });

  return report;
};